<template>
  <button type="button" class="btn btn-link tooltip-component mt-2" data-toggle="tooltip" :data-placement="placement || 'top'" :title="title">
    <slot></slot>
  </button>
</template>

<script>
  export default {
    name: 'tooltip',
    props: {
      title: String,
      placement: String
    },
    mounted () {
      $('.tooltip-component').tooltip();
    }
  }
</script>



// WEBPACK FOOTER //
// tooltip.vue